import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography, useTheme } from '@mui/material';
import { Send } from 'lucide-react';

interface SubmitButtonNodeData {
  label?: string;
}

const SubmitButtonNode: React.FC<NodeProps<SubmitButtonNodeData>> = ({ data }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.dark}`,
        borderRadius: 2,
        minWidth: 200,
        boxShadow: theme.shadows[2],
        cursor: 'default',
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{
          background: theme.palette.primary.dark,
          width: 8,
          height: 8,
        }}
      />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          px: 3,
          py: 1.5,
        }}
      >
        <Send size={16} color="#fff" />
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#fff' }}>
          {data?.label || 'Submit Form'}
        </Typography>
      </Box>

      <Box
        sx={{
          px: 2,
          py: 1,
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderTop: '1px solid rgba(255,255,255,0.2)',
        }}
      >
        <Typography
          variant="caption"
          sx={{ color: 'rgba(255,255,255,0.8)', textAlign: 'center', display: 'block' }}
        >
          End of form
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(SubmitButtonNode);
